import React, { useState, useContext, useEffect, useRef } from "react";
import { UserInformationContext, C4FStatusContext, ReferenceDataContext, InfoModalContext } from "../main/App";
import { Table, Row, Col, Button, ButtonGroup, Container, Dropdown, DropdownButton } from 'react-bootstrap';
import '../css/general.css';
import C4FSimpleTable from "../common/C4FSimpleTable";
import C4FChat from "../common/C4FChat";
import { getC4FCodeForCountryCode, getUnicodeFlag } from "../common/Helpers";

function NationsCommittee(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { countries, notificationTypes } = useContext(ReferenceDataContext);
  const { showTeamInfo } = useContext(InfoModalContext);
  const [tab, setTab] = useState('requests');
  const [requests, setRequests] = useState(null);
  const [filter, setFilter] = useState([]);
  const [selectedPredefinedFilter, setSelectedPredefinedFilter] = useState('');
  const [similarRiders, setSimilarRiders] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [notificationType, setNotificationType] = useState(null);
  const mounted = useRef(false);

  function loadRequests() {
    handleBackendRequest('GET', '/rider', null, { context: 'nationsCommittee' },
      function (result) {
        setRequests(result);
      });
  }

  function handleCloneCheck() {
    handleBackendRequest('GET', '/rider', null, { context: 'fuzzySearch', riderName: selectedRequest.firstNames + ' ' + selectedRequest.lastNames },
      function (result) {
        setSimilarRiders(result);
      });

  }

  function handleSetSelectedRequest(selectedRequest) {
    setSelectedRequest(selectedRequest);
    setSimilarRiders(null);
  }

  function handleSetStatus(status, result, caseHandlerId, reviewerId, requestClarification = false) {
    handleBackendRequest('POST', '/rider/' + selectedRequest.riderId + '/processNationsCommitteeRequest', null,
      {
        status: status,
        result: result,
        caseHandlerId: caseHandlerId,
        reviewerId: reviewerId,
        requestClarification: requestClarification
      },
      function (result) {
        setRequests(requests.filter(r => r.riderId !== selectedRequest.riderId).concat([result]));
        handleSetSelectedRequest(result);
      });

  }

  function handleSetFilter(filter) {
    setSelectedPredefinedFilter(filter);
    switch (filter) {
      case 'All Requests':
        setFilter([]);
        break;
      case 'My Requests':
        setFilter([{
          columnName: 'caseHandlerName',
          type: 'text',
          value: userInformation.userName,
          regex: userInformation.userName,
          valid: true
        }]);
        break;
      case 'Open Requests':
        setFilter([{
          columnName: 'status',
          type: 'text',
          value: 'Open|Ass',
          regex: 'Open|Ass',
          valid: true
        }]);
        break;
      case 'Unassigned Requests':
        setFilter([{
          columnName: 'status',
          type: 'text',
          value: 'Open',
          regex: 'Open',
          valid: true
        }]);
        break;
      case 'To Be Confirmed':
        setFilter([{
          columnName: 'status',
          type: 'text',
          value: 'Decided',
          regex: 'Decided',
          valid: true
        },
        {
          columnName: 'caseHandlerName',
          type: 'text',
          value: '^((?!' + userInformation.userName + ').)*$',
          regex: '^((?!' + userInformation.userName + ').)*$',
          valid: true
        }]);
        break;
      default: return;
    }
  }

  useEffect(() => {
    if (!requests) {
      loadRequests();
      handleSetFilter('Open Requests');
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  return <Container fluid className="m-1">
    <Row className="justify-content-center my-1">
      <ButtonGroup>
        <Button variant={(tab === 'requests') ? 'primary' : 'outline-primary'} onClick={() => setTab('requests')}>Requests</Button>
        <Button variant={(tab === 'chat') ? 'primary' : 'outline-primary'} onClick={() => setTab('chat')}>Nations Committee Chat</Button>
        <Button variant={(tab === 'instructions') ? 'primary' : 'outline-primary'} onClick={() => setTab('instructions')}>Instructions</Button>
      </ButtonGroup>
    </Row>
    {tab === 'requests' && requests ?
      <>
        <Row className=" d-flex c4f-stats my-1" style={{ height: "350px", overflow: "auto" }}>
          <Col>
            <ButtonGroup className="my-1">
              <Button size="sm" variant={'secondary'} disabled>Predefined Filter</Button>
              <DropdownButton size="sm" as={ButtonGroup} title={selectedPredefinedFilter}
                variant={'secondary'} onSelect={(filter, e) => handleSetFilter(filter)}>
                <Dropdown.Item key={1} eventKey={'All Requests'}>All Requests</Dropdown.Item>
                <Dropdown.Item key={2} eventKey={'My Requests'}>My Requests</Dropdown.Item>
                <Dropdown.Item key={3} eventKey={'Unassigned Requests'}>Unassigned Requests</Dropdown.Item>
                <Dropdown.Item key={4} eventKey={'Open Requests'}>Open Requests</Dropdown.Item>
                <Dropdown.Item key={5} eventKey={'To Be Confirmed'}>To Be Confirmed</Dropdown.Item>
              </DropdownButton>
            </ButtonGroup>
            <C4FSimpleTable key={'requests'}
              initialSortingColumn={'id'}
              initialSortingAscending={false}
              highlightCriteriaKey={'id'}
              highlightCriteriaValue={selectedRequest !== null ? selectedRequest.id : null}
              data={requests.map(record => ({
                ...record,
                currentNationalityFlag: getUnicodeFlag(record.nationality),
                currentNationalityC4fCode: getC4FCodeForCountryCode(countries, record.nationality),
                originalNationalityFlag: getUnicodeFlag(record.originalNationality),
                originalNationalityC4fCode: getC4FCodeForCountryCode(countries, record.originalNationality),
                riderName: record.firstNames + ' ' + record.lastNames,
                clarificationRequestedSymbol: record.clarificationRequested ? 'Yes' : 'No',
                caseHandlerName: 'caseHandlerName' in record ? record.caseHandlerName : '',
                reviewerName: 'reviewerName' in record ? record.reviewerName : ''
              }))}
              filters={filter}
              hideColumnVisibility={true}
              refreshTable={loadRequests}
              rowMetadata={[
                { columnName: 'id', columnDescription: 'ID', cellClickEvent: handleSetSelectedRequest },
                browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                  { columnName: 'originalNationalityFlag', columnDescription: 'old' }
                  :
                  { columnName: 'originalNationalityC4fCode', columnDescription: 'old', columnType: 'flag' },
                browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                  { columnName: 'currentNationalityFlag', columnDescription: 'new' }
                  :
                  { columnName: 'currentNationalityC4fCode', columnDescription: 'new', columnType: 'flag' },
                { columnName: 'riderName', columnDescription: 'Name', cellClickEvent: handleSetSelectedRequest },
                { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                { columnName: 'status', columnDescription: 'Status' },
                { columnName: 'clarificationRequestedSymbol', columnDescription: 'Clarif.' },
                { columnName: 'result', columnDescription: 'Result' },
                { columnName: 'caseHandlerName', columnDescription: 'Handler' },
                { columnName: 'reviewerName', columnDescription: 'Reviewer' }
              ]}
            />
          </Col>
        </Row>
        {selectedRequest !== null ?
          <>
            <Row className=" d-flex c4f-stats my-2">
              <Col>
                <h5>NC Request {selectedRequest.firstNames + ' ' + selectedRequest.lastNames}</h5>

                <ButtonGroup className="ml-1" size="sm">
                  <Button disabled variant={'secondary'}>Action</Button>
                  {['Open', 'Assigned', 'Decided'].includes(selectedRequest.status) ?
                    <Button size="sm" onClick={() => handleCloneCheck()} variant={'primary'}>Clone Check</Button>
                    : null}
                  {selectedRequest.status === 'Open' ?
                    <Button onClick={() => handleSetStatus('Assigned', selectedRequest.result, userInformation.userID, 0)} variant={'success'}>Pick up</Button>
                    : null}
                  {selectedRequest.status === 'Assigned' ?
                    <>
                      <Button disabled={selectedRequest.caseHandlerId !== userInformation.userID}
                        onClick={() => handleSetStatus(selectedRequest.status, selectedRequest.result, selectedRequest.caseHandlerId, selectedRequest.reviewerId, true)} variant={'warning'}>Request Clarification</Button>
                      <Button disabled={selectedRequest.caseHandlerId !== userInformation.userID}
                        onClick={() => handleSetStatus('Open', 'Open', 0, 0)} variant={'secondary'}>Release</Button>
                    </>
                    : null}
                  {selectedRequest.status === 'Decided' ?
                    <>
                      <Button disabled={selectedRequest.caseHandlerId === userInformation.userID}
                        onClick={() => handleSetStatus('Confirmed', selectedRequest.result, selectedRequest.caseHandlerId, userInformation.userID)} variant={'success'}>Confirm Decision</Button>
                      <Button onClick={() => handleSetStatus('Assigned', 'Open', selectedRequest.caseHandlerId, userInformation.userID)} variant={'warning'}>Reopen</Button>
                    </>
                    : null}
                  {selectedRequest.status === 'Confirmed' ?
                    <Button onClick={() => handleSetStatus('Archived', selectedRequest.result, selectedRequest.caseHandlerId, selectedRequest.reviewerId)} variant={'secondary'}>Archive</Button>
                    : null}
                </ButtonGroup>

                <ButtonGroup className="ml-1" size="sm">
                  <Button disabled variant={'secondary'}>Status</Button>
                  <Button disabled variant={'primary'}>{selectedRequest.status}</Button>
                </ButtonGroup>

                <ButtonGroup className="ml-1" size="sm">
                  <Button disabled variant={'secondary'}>Result</Button>
                  {['Decided', 'Confirmed', 'Archived'].includes(selectedRequest.status) ?
                    <Button disabled variant={selectedRequest.result === 'Accepted' ? 'success' : 'danger'}>{selectedRequest.result}</Button>
                    :
                    <>
                      <Button disabled
                        onClick={() => handleSetStatus('Assigned', 'Open', selectedRequest.caseHandlerId, selectedRequest.reviewerId)}
                        variant={(selectedRequest.result !== 'Open' ? 'outline-' : '') + 'warning'}>Open</Button>
                      <Button disabled={selectedRequest.status === 'Open'}
                        onClick={() => handleSetStatus('Decided', 'Clone', selectedRequest.caseHandlerId, selectedRequest.reviewerId)}
                        variant={(selectedRequest.result !== 'Clone' ? 'outline-' : '') + 'danger'}>Clone</Button>
                      <Button disabled={selectedRequest.status === 'Open'}
                        onClick={() => handleSetStatus('Decided', 'UnrealisticName', selectedRequest.caseHandlerId, selectedRequest.reviewerId)}
                        variant={(selectedRequest.result !== 'UnrealisticName' ? 'outline-' : '') + 'danger'}>Unrealistic Name</Button>
                      <Button disabled={selectedRequest.status === 'Open'}
                        onClick={() => handleSetStatus('Decided', 'WrongNation', selectedRequest.caseHandlerId, selectedRequest.reviewerId)}
                        variant={(selectedRequest.result !== 'WrongNation' ? 'outline-' : '') + 'danger'}>Wrong Nation</Button>
                      <Button disabled={selectedRequest.status === 'Open'}
                        onClick={() => handleSetStatus('Decided', 'Accepted', selectedRequest.caseHandlerId, selectedRequest.reviewerId)}
                        variant={(selectedRequest.result !== 'Accepted' ? 'outline-' : '') + 'success'}>Accepted</Button>
                    </>
                  }
                </ButtonGroup>
              </Col>
            </Row>
            <Row className=" d-flex c4f-stats my-2">
              <Col className="col-6">

                <Table className="mt-1" size="sm" striped>
                  <tbody>
                    <tr>
                      <td><b><u>RIDER INFO</u></b></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><b>Name</b></td>
                      <td>{selectedRequest.firstNames + ' ' + selectedRequest.lastNames}</td>
                    </tr>
                    <tr>
                      <td><b>Additional Information</b></td>
                      <td>{selectedRequest.additionalInformation}</td>
                    </tr>
                    <tr>
                      <td><b>Owner</b></td>
                      <td className="c4f-stats-td-clickable" onClick={() => showTeamInfo(selectedRequest)}>{selectedRequest.teamName}</td>
                    </tr>
                    <tr>
                      <td><b>Rider Type</b></td>
                      <td>{selectedRequest.riderStatus}</td>
                    </tr>
                    <tr>
                      <td><b>Original Nationality</b></td>
                      <td>{getUnicodeFlag(selectedRequest.originalNationality)} {selectedRequest.originalNationality !== 'None' ? countries.find(c => c.countryCode === selectedRequest.originalNationality).country : 'None'}</td>
                    </tr>
                    <tr>
                      <td><b>Current Nationality</b></td>
                      <td>{getUnicodeFlag(selectedRequest.nationality)} {selectedRequest.nationality !== 'None' ? countries.find(c => c.countryCode === selectedRequest.nationality).country : 'None'}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col className="col-6">
                <Table className="mt-1" size="sm" striped>
                  <tbody>
                    <tr>
                      <td><b><u>CASE INFO</u></b></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><b>ID</b></td>
                      <td>{selectedRequest.id}</td>
                    </tr>
                    <tr>
                      <td><b>Handler</b></td>
                      <td>{selectedRequest.caseHandlerName} {selectedRequest.caseHandlerId !== 0 ? '(' + selectedRequest.caseHandlerId + ')': null}</td>
                    </tr>
                    <tr>
                      <td><b>Reviewer</b></td>
                      <td>{selectedRequest.reviewerName} {selectedRequest.reviewerId !== 0 ? '(' + selectedRequest.reviewerId + ')': null}</td>
                    </tr>
                    <tr>
                      <td><b>Clarification Requested</b></td>
                      <td>{selectedRequest.clarificationRequestedSymbol}</td>
                    </tr>
                    <tr>
                      <td><b>Request Status</b></td>
                      <td>{selectedRequest.status}</td>
                    </tr>
                    <tr>
                      <td><b>Request Result</b></td>
                      <td>{selectedRequest.result}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            {similarRiders !== null ?
              <Row className=" d-flex c4f-stats my-2">
                <Col>
                  <h5>Similar Names</h5>
                  <C4FSimpleTable key={'similarRiders'}
                    initialSortingColumn={'riderName'}
                    initialSortingAscending={true}
                    data={similarRiders
                      .filter(r => r.firstNames !== selectedRequest.firstNames && r.lastNames !== selectedRequest.lastNames)
                      .map(record => ({
                        ...record,
                        flag: getUnicodeFlag(record.nationality),
                        c4fCode: getC4FCodeForCountryCode(countries, record.nationality),
                        riderName: record.firstNames + ' ' + record.lastNames
                      }))}
                    hideColumnVisibility={true}
                    rowMetadata={[
                      { columnName: 'riderName', columnDescription: 'Name' },
                      browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                        { columnName: 'flag', columnDescription: '\u2691' }
                        :
                        { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag' },
                      { columnName: 'nickname', columnDescription: 'Nickname' },
                      { columnName: 'additionalInformation', columnDescription: 'Add. Info' },
                      { columnName: 'ownerName', columnDescription: 'Team' }
                    ]}
                  />
                </Col>
              </Row>
              : null}
          </>
          : null}
      </>
      : null}
    {tab === 'chat' ?
      <div className="row justify-content-center">
        <div className="col m-0 p-1">
          <h5>NC Chat</h5>
          <div className="border border-secondary px-3 py-0" style={{ minWidth: 300, maxWidth: 700, backgroundColor: 'rgba(255, 255, 255, 1)' }}>
          <C4FChat key={'nationsCommitteeChat'} type="nationsCommittee"
            mode="readwrite"
            chat={0} user={userInformation.userName}
            height={500} />
        </div>
        </div>
      </div>
      : null}
    {tab === 'instructions' ?
      <Row className="justify-content-center">
        <Col className="col-8">
          <h4>Instructions</h4>
          <h5>States</h5>
          <p>
            Nations Committee requests are automatically generated whenever a user names a rider.
            A Nations Committee request is proceeding through the following states:
            <ul>
              <li><b>Open:</b> Initial state of the request</li>
              <li><b>Assigned:</b> When a NC user picks up a request, it becomes assigned, only allowing further updates to the assignee.</li>
              <li><b>Clarification:</b> If the assignee is unsure about a name, he can request clarification from the user. In that case an automatic message is sent to the user requesting him / her to provide proof or more information on the rider name</li>
              <li><b>Decided:</b> After the assignee decides, wheather or not the rider name is suitable, other users may confirm the decision</li>
              <li><b>Confirmed:</b> After confirmation the team owner is notified in case of a negative decision, and the request stays visible it's archived</li>
              <li><b>Archived:</b> Archived requests are no longer displayed</li>
            </ul>
          </p>
          <h5>Message Types</h5>
          <C4FSimpleTable key={'messageTypes'}
            data={notificationTypes.filter(nt => nt.category === 'nationsCommittee')}
            hideColumnVisibility={true}
            hideFilterButtons={true}
            rowMetadata={[
              { columnName: 'type', columnDescription: 'Type', cellClickEvent: setNotificationType },
              { columnName: 'description', columnDescription: 'Description' }
            ]}
          />
          {notificationType !== null ?
            <>
              <h5>Message Example</h5>
              <p><b>Subject: </b>{notificationType.subject}</p>
              <p>{notificationType.notification}</p>
            </>
            : null}

        </Col>
      </Row>
      : null}

  </Container >;

}

export default NationsCommittee;
